<!-- Skeleton Table (Shown when isLoading is true) -->
@if (!usingAutoLoad() && isLoading()) {
  <table mat-table [dataSource]="skeletonRows" class="mat-elevation-z8">
    @for (column of displayedColumns(); track column; let i = $index) {
      <ng-container [matColumnDef]="column">
        <!-- <th mat-header-cell *matHeaderCellDef>
      <div class="skeleton-placeholder-text"></div>
    </th> -->
        <th
          mat-header-cell
          *matHeaderCellDef
          class="tableHeaderCell"
          [style.min-width]="getColumnMinWidth(i)"
        >
          {{ headers()[i] }}
        </th>
        <td mat-cell *matCellDef>
          <div class="skeleton-placeholder-text"></div>
        </td>
      </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: columnsToDisplay"
      class="skeleton-row"
    ></tr>
  </table>
}
@if ((!usingAutoLoad() && !isLoading()) || usingAutoLoad()) {
  <!-- Real Data Table (Shown when isLoading is false) -->
  <!-- Use dataSource for sortable tables, data() for non-sortable -->
  @if (enableSorting()) {
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      [matSortActive]="defaultSortColumn()"
      [matSortDirection]="defaultSortDirection()"
      [matSortDisableClear]="false"
      (matSortChange)="onSortChange($event)"
      class="mat-elevation-z8"
    >
      @for (column of displayedColumns(); track column; let i = $index) {
        <ng-container [matColumnDef]="column">
          <!-- Header cell with sorting -->
          @if (selectColumn() && column == selectColumn()) {
            <th
              mat-header-cell
              *matHeaderCellDef
              class="tableHeaderCell select-column-cell"
              [style.min-width]="getColumnMinWidth(i)"
            >
              <mat-checkbox
                [checked]="isAllRowsSelected()"
                [indeterminate]="isSomeRowsSelected()"
                [disabled]="!hasSelectableRows()"
                (change)="toggleAllSelection($event)"
                matTooltip="Select all"
              ></mat-checkbox>
            </th>
          } @else {
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="tableHeaderCell"
              [style.min-width]="getColumnMinWidth(i)"
            >
              {{ headers()[i] }}
            </th>
          }
          <td
            mat-cell
            *matCellDef="let element"
            [class.select-column-cell]="selectColumn() && column == selectColumn()"
            [style]="customStyle()"
            [ngClass]="getCustomColumnClass(element, column)"
            (click)="cellClick(element, column)"
          >
            @if (column != customBoolColumn() && column != customBoolWithFalseColumn()) {
              <span [class.link]="columnsLink().indexOf(column) > -1">{{
                element[column]
              }}</span>
            }
            @if (column == customBoolColumn() && element[customBoolColumn()]) {
              <mat-icon
                [class.success-light]="!customBoolTrueColor()"
                [style.color]="customBoolTrueColor() || null"
              >
                check_small
              </mat-icon>
            }
            @if (
              column == customBoolColumn() &&
              customBoolShowFalseIcon() &&
              !element[customBoolColumn()]
            ) {
              <mat-icon [color]="customBoolFalseIconColor()">{{ customBoolFalseIcon() }}</mat-icon>
            }
            @if (column == customBoolWithFalseColumn()) {
              @if (element[customBoolWithFalseColumn()]) {
                <mat-icon class="success-light">check_small</mat-icon>
              } @else {
                <mat-icon color="warn">error</mat-icon>
              }
            }

            @if (
              column == "button" &&
              (!element.hasOwnProperty("showButton") ||
                element["showButton"] == true)
            ) {
              <button mat-button color="primary" (click)="buttonClick(element)">
                <mat-icon>read_more</mat-icon>
              </button>
            }
            @if (
              column == "dequeue" &&
              (!element.hasOwnProperty("status") ||
                element["status"] == "queued" ||
                element["status"] == "requeued")
            ) {
              <button
                mat-icon-button
                color="warn"
                matTooltip="Remove from queue"
                (click)="$event.stopPropagation(); buttonClick(element)"
              >
                <mat-icon>remove_circle</mat-icon>
              </button>
            }
            @if (selectColumn() && column == selectColumn()) {
              <mat-checkbox
                [checked]="isRowSelected(element)"
                [disabled]="!isRowSelectionEnabled(element)"
                [matTooltip]="
                  !isRowSelectionEnabled(element)
                    ? 'Selection disabled'
                    : isRowSelected(element)
                      ? 'Deselect'
                      : 'Select'
                "
                (click)="$event.stopPropagation()"
                (change)="toggleRowSelectionByChecked($event.checked, element)"
              ></mat-checkbox>
            }
          </td>
        </ng-container>
      }
      <!-- Disclaimer column -->
      <ng-container matColumnDef="disclaimer">
        <td
          mat-footer-cell
          *matFooterCellDef
          colspan="2"
          style="font-size: 12px; font-style: italic; color: gray"
        >
          {{ footer() }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: columnsToDisplay"
        (click)="rowClick(row)"
        [class.selected]="row === selectedRow"
      ></tr>

      <tr
        mat-footer-row
        *matFooterRowDef="['disclaimer']"
        style="height: 18px"
      ></tr>
    </table>
  } @else {
    <!-- Non-sortable table (original implementation) -->
    <table mat-table [dataSource]="data()" class="mat-elevation-z8">
      @for (column of displayedColumns(); track column; let i = $index) {
        <ng-container [matColumnDef]="column">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="tableHeaderCell"
            [class.select-column-cell]="selectColumn() && column == selectColumn()"
            [style.min-width]="getColumnMinWidth(i)"
          >
            @if (selectColumn() && column == selectColumn()) {
              <mat-checkbox
                [checked]="isAllRowsSelected()"
                [indeterminate]="isSomeRowsSelected()"
                [disabled]="!hasSelectableRows()"
                (change)="toggleAllSelection($event)"
                matTooltip="Select all"
              ></mat-checkbox>
            } @else {
              {{ headers()[i] }}
            }
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            [class.select-column-cell]="selectColumn() && column == selectColumn()"
            [style]="customStyle()"
            [ngClass]="getCustomColumnClass(element, column)"
            (click)="cellClick(element, column)"
          >
            @if (column != customBoolColumn() && column != customBoolWithFalseColumn()) {
              <span [class.link]="columnsLink().indexOf(column) > -1">{{
                element[column]
              }}</span>
            }
            @if (column == customBoolColumn() && element[customBoolColumn()]) {
              <mat-icon
                [class.success-light]="!customBoolTrueColor()"
                [style.color]="customBoolTrueColor() || null"
              >
                check_small
              </mat-icon>
            }
            @if (
              column == customBoolColumn() &&
              customBoolShowFalseIcon() &&
              !element[customBoolColumn()]
            ) {
              <mat-icon [color]="customBoolFalseIconColor()">{{ customBoolFalseIcon() }}</mat-icon>
            }
            @if (column == customBoolWithFalseColumn()) {
              @if (element[customBoolWithFalseColumn()]) {
                <mat-icon class="success-light">check_small</mat-icon>
              } @else {
                <mat-icon color="warn">error</mat-icon>
              }
            }

            @if (
              column == "button" &&
              (!element.hasOwnProperty("showButton") ||
                element["showButton"] == true)
            ) {
              <button mat-button color="primary" (click)="buttonClick(element)">
                <mat-icon>read_more</mat-icon>
              </button>
            }
            @if (
              column == "dequeue" &&
              (!element.hasOwnProperty("status") ||
                element["status"] == "queued" ||
                element["status"] == "requeued")
            ) {
              <button
                mat-icon-button
                color="warn"
                matTooltip="Remove from queue"
                (click)="$event.stopPropagation(); buttonClick(element)"
              >
                <mat-icon>remove_circle</mat-icon>
              </button>
            }
            @if (selectColumn() && column == selectColumn()) {
              <mat-checkbox
                [checked]="isRowSelected(element)"
                [disabled]="!isRowSelectionEnabled(element)"
                [matTooltip]="
                  !isRowSelectionEnabled(element)
                    ? 'Selection disabled'
                    : isRowSelected(element)
                      ? 'Deselect'
                      : 'Select'
                "
                (click)="$event.stopPropagation()"
                (change)="toggleRowSelectionByChecked($event.checked, element)"
              ></mat-checkbox>
            }
          </td>
        </ng-container>
      }
      <!-- Disclaimer column -->
      <ng-container matColumnDef="disclaimer">
        <td
          mat-footer-cell
          *matFooterCellDef
          colspan="2"
          style="font-size: 12px; font-style: italic; color: gray"
        >
          {{ footer() }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: columnsToDisplay"
        (click)="rowClick(row)"
        [class.selected]="row === selectedRow"
      ></tr>

      <tr
        mat-footer-row
        *matFooterRowDef="['disclaimer']"
        style="height: 18px"
      ></tr>
    </table>
  }
}
